import { mapRange } from '@wix/wow-utils';
import { getCssUnits, getMouseTransitionEasing, } from '../../../utils/animationsUtils';
export const name = 'TrackMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, distance = { value: 200, type: 'px' }, axis = 'both', transitionDuration, transitionEasing = 'linear', } = {}) {
    const element = elements[0];
    const invert = inverted ? -1 : 1;
    if (transitionDuration) {
        element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasing(transitionEasing)}`;
    }
    return {
        progress({ x: progressX, y: progressY }) {
            let translateX = 0;
            let translateY = 0;
            // if progressX === 0, translateX === -distance
            // if progressX === 0.5, translateX === 0
            // if progressX === 1, translateX === distance
            if (axis === 'both' || axis === 'horizontal') {
                translateX =
                    mapRange(0, 1, -distance.value, distance.value, progressX) * invert;
            }
            if (axis === 'both' || axis === 'vertical') {
                translateY =
                    mapRange(0, 1, -distance.value, distance.value, progressY) * invert;
            }
            const units = getCssUnits(distance.type);
            element.style.transform = `translateX(${translateX}${units}) translateY(${translateY}${units}) rotate(var(--comp-rotate-z, 0deg))`;
        },
        kill() {
            element.style.transform = '';
            element.style.transition = '';
        },
    };
}
//# sourceMappingURL=trackMouse.js.map